import React from 'react';
import { useTranslation } from 'react-i18next';

const GooglePlayBadge = ({packageName}) => {
  const { t } = useTranslation();
  
  return (
    <a href={`https://play.google.com/store/apps/details?id=${packageName}`} target="_blank" rel="noopener noreferrer">
      <img 
        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
        alt={t('common.get_app')}
        style={{height: "90px"}}
      />
    </a>
  );
};

export default GooglePlayBadge;